// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"HideProfileButton_wrapper__3-_3M","button":"HideProfileButton_button__2K5cJ","hide":"HideProfileButton_hide__1Xvx6"};